import React from 'react'
import styled from 'styled-components';
import CardIconHeader from './Components/CardIconHeader';
import BankingFinanceIcon from '../../../assets/icons/BankingFinanceIcon';
import { useTheme } from '../../../middleware/ThemeContext';
import StyledText from '../../../components/StyledComponents/StyledText';

const OutstandingBalance = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme}>
        <CardIconHeader 
            icon={<BankingFinanceIcon size={24} color={theme.CorporateTheme.colors.ultraMarineBlue} /> }
            title='Outstanding Balance'
            count="$40,689.00"
            iconBgColor='rgba(228, 228, 255, 0.5)'
        />
        <hr />
        <StyledText
            fontSize='14px'
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.blueberry}
            fontStyle='italic'
            style={{ textAlign: 'right' }}
        >
            24 overdue invoices
        </StyledText>
    </DashboardCard>
  )
}

export default OutstandingBalance

export const DashboardCard = styled('div')(({ theme }) => ({
    padding: '25px',
    background: theme.CorporateTheme.colors.background,
    borderRadius: theme.CorporateTheme.borderRadius,
}));